import React from "react"
import styles from "./fixed-header.module.css"
// import logo from "../images/favicon.ico"
import "../font-awesome-4.7.0/css/font-awesome.min.css"
import plantpathology from "../images/plant-pathology.jpg"
import delhitemp from "../images/delhi-temperature.gif"
import obgrobot from "../images/object-following-robot.jpeg"
import babynames from "../images/baby-names.png"
// import {SocialIcon} from "react-social-icons"
import propic from "../images/pro-pic.jpeg"

import {FaKaggle, FaFacebookF, FaGithub, FaInstagram, FaLinkedinIn, FaTwitter, FaEnvelope, FaLaptopCode, FaTools, FaHeart, FaSmile, FaBlackTie, FaAddressCard, FaRegSmile, FaGitAlt, FaRegCopyright, FaBookOpen} from "react-icons/fa"
import {BsLightning} from "react-icons/bs"
import {RiFocus2Line, RiTeamLine, RiWechatLine} from "react-icons/ri"
import {GiWhiteBook} from "react-icons/gi"
import {IoMdContact} from "react-icons/io"
import {MdEmail} from "react-icons/md"


import { IconContext } from "react-icons"
// import backgroundImage from "../images/abstract chaotic.jpg"

export default function Home() {
  return (
    <body>
      <title>Meet Ranoliya</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      <div className={styles.backgroundImage} id="introduction">
        
        <div className={styles.navbar}>
          <a className={styles.mylogo} href="#introduction"><b>MR.5</b></a>
          <a href="#about">About</a>
          <a href="#skillset">Skillset</a>
          <a href="#values">Values</a>
          <a href="#projects">Projects</a>
          <a href="#mystory">My Story</a>
          <a href="mailto:memr5.personal@gmail.com">Contact</a>
          {/* <a className={styles.namebanner} href="introduction">Portfolio</a> */}
        </div>

        <img className={styles.propic} src={propic} alt="memr5"></img>
        <h1 className={styles.shadow} style={{color:"white",marginTop:"20px"}}>Meet Ranoliya</h1>
        <h2 className={styles.shadow} style={{color: "white",marginTop:"20px"}}>Machine Learning, Deep Learning & Computer Vision Enthusiast</h2>
        
        {/* <div className={styles.social}>
          <div><a href="https://www.facebook.com/meet.ranoliya.9"><SocialIcon network="facebook" bgColor="#c3073f"/></a></div>
          <div><a href="https://github.com/memr5"><SocialIcon  network="github" bgColor="white"/></a></div>
          <div><a href="https://www.linkedin.com/in/mr5/"><SocialIcon  network="linkedin" bgColor="#c3073f"/></a></div>
          <div><a href="https://www.instagram.com/memr5__/"><SocialIcon  network="instagram" bgColor="white"/></a></div>
          <div><a href="https://twitter.com/me_mr5_"><SocialIcon  network="twitter" bgColor="#c3073f"/></a></div>
        </div> */}

        <div className={styles.socialicon} >
          <a href="https://www.linkedin.com/in/mr5/">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaLinkedinIn/>
            </IconContext.Provider> 
          </a>

          <a href="https://github.com/memr5">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaGithub/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.kaggle.com/meemr5">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaKaggle/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.facebook.com/meet.ranoliya.9">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaFacebookF/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.instagram.com/memr5__/">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaInstagram/>
            </IconContext.Provider> 
          </a>

          <a href="https://twitter.com/me_mr5_">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaTwitter/>
            </IconContext.Provider> 
          </a>
        </div>

      
      </div>

      <div className={styles.about} id="about">
        
        <span className={styles.divnumber}>0.  </span>
        <span className={styles.divname}>
          About Me!
        </span>

        <div className={styles.aboutcontent}>
          <p>Hello! I'm Meet. <br></br>
          I'm a <b>Machine Learning Enthusiast</b> full of passion to learn & build something new everyday. <br></br>
          I have worked on projects of various scales, both as solo and as a part of a team.</p>
        </div>
        <div className={styles.aboutcontent}>
          <p>Currently, I'm in 3rd year of B.Tech in Information & Communication Technology and <br></br>
          I'm looking for <b>Internship oppurtunities</b> in <b>Machine Learning</b> domain.</p>
        </div>
      </div>

      <div className={styles.skillset} id="skillset">
        <div className={styles.center}>
          <span className={styles.divnumber}>1. </span><span className={styles.divname}>Skillset!</span>
          <p>As an individual with interest and experience in various fields,<br></br>
          I have developed a broad and deep skillset.</p>
        </div>

        <div>
          <div className={styles.skillitem}>
            <h2 className={styles.label}>
              <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
                <FaLaptopCode/>
              </IconContext.Provider>
              Programmer
            </h2>
            <p>Being a person who loves programming, I always
            prefer to write <b>clean & robust</b> code.</p>
            
            <p>I'm familiar with many programming languages like,
            <b>Python, C/C++ & Java</b>. Being a <b>quick-learner</b>,
            I always like to learn new things.</p>
            <br></br>
            <br></br>
          </div>

          <div className={styles.skillitem}>
            <h2 className={styles.label}>
              <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
                <FaTools/>
              </IconContext.Provider>
              Tools & Technologies
            </h2><br></br>
            <span className={styles.tools}>tensorflow/keras</span>
            <span className={styles.tools}>sklearn</span>
            <span className={styles.tools}>open-CV</span>
            <span className={styles.tools}>Matlab/Scilab</span>
            <br></br>
            <span className={styles.tools}>numpy</span>
            <span className={styles.tools}>pandas</span>
            <br></br>
            <span className={styles.tools}>matplotlib</span>
            <span className={styles.tools}>seaborn</span>
            <span className={styles.tools}>plotly</span>
            <span className={styles.tools}>tableau</span>
            <br></br>
            <span className={styles.tools}>git</span>
            <span className={styles.tools}>MySQL</span>
            <span className={styles.tools}>HTML/CSS</span>
            <span className={styles.tools}>Gatsby</span>
            <br></br>
            <span className={styles.tools}>Raspberry-pi</span>
            <span className={styles.tools}>Arduino</span>
            <br></br>
            <br></br>
          </div>

        </div>
      
      </div>

      <div className={styles.values} id="values">
        <div className={styles.center}>
          <span className={styles.divnumber} style={{textShadow:"2px 2px 4px rgb(0,0,0)"}}>2. </span><span className={styles.divname} style={{color:"white",textShadow:"2px 2px 4px rgb(0,0,0)"}}>Values!</span>
          <p style={{fontSize:"20px", color:"white"}}>Working well in different Environments & with various kinds of people is important.<br></br>
          Here's an insight into how I work.
          </p>
        </div>
              
        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}>
            <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <BsLightning/>
            </IconContext.Provider>
            Quick-Learner
          </h1>
          <div className={styles.valueitemtext}>
            <p>
              Curiosity and love for learning new<br></br>
              things make me a quick learner.<br></br>
              This helps me adapt the <br></br>
              fast-paced environments. 
            </p>
          </div>
        </div>

        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}>
            <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <FaHeart/>
            </IconContext.Provider>
            Passion
          </h1>
          <div className={styles.valueitemtext}>
            <p>
              I love what I do, that is why<br></br>
              I put 100% effort into my work.<br></br>
              I enjoy working with similar kind<br></br>
              of people.<br></br>
            </p>
          </div>
        </div>
        
        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <RiTeamLine/>
            </IconContext.Provider>Cooperation</h1>
          <div className={styles.valueitemtext}>
            <p>
              Working in a team is very important<br></br>
              to achieve the desired results.<br></br>
              I'm easy going and a<br></br>
              fun person.
            </p>
          </div>
        </div>
        
        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <RiWechatLine/>
            </IconContext.Provider>Communication</h1>
          <div className={styles.valueitemtext}>
            <p>
              Team communication in particular is<br></br>
              important to master. For a team to<br></br>
              function effectively, there must be<br></br>
              open channels of communication. I'm<br></br>
              good at listening and communicating<br></br>
              ideas.
            </p>
          </div>
        </div>

        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <RiFocus2Line/>
            </IconContext.Provider>Focused</h1>
          <div className={styles.valueitemtext}>
            <p>
              A focused mind enables you to<br></br>
              carry out everything faster,<br></br>
              more efficiently, and with<br></br>
              fewer mistakes. I work with<br></br>
              fully focused mindset to carry<br></br>
              out the work effectively.
            </p>
          </div>
        </div>

        <div className={styles.valueitem}>
          <h1 style={{color:"white"}}><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <FaSmile/>
            </IconContext.Provider>Calmness</h1>
          <div className={styles.valueitemtext}>
            <p>
              Staying calm while dealing<br></br>
              with difficult situations is<br></br>
              crucial. I'm a calm person and this<br></br>
              helps me tackle problems<br></br>
              efficiently.<br></br><br></br>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.projects} id="projects">
        <div className={styles.center}>
          <span className={styles.divnumber}>3. </span><span className={styles.divname}>Projects!</span>
          <br></br>
          <br></br>
          <span>Here are some the projects I have worked on over the years.</span><br></br>
          <span>This includes personal & group projects.</span>
        </div>

        <div className={styles.projectcard}>
          <img src={plantpathology} alt="Plant-Pathology" className={styles.projectimage}></img>
          <div className={styles.projectdescription}>
            <h2>Identifying Foliar Diseases in Apple trees<span className={styles.projectyear}> - <em>2020</em></span></h2>
            <p>The goal of this project was to distinguish between many diseases using the images of the leaves.
              The main focused of this project was to deal with rare classes and
              address depth perception—angle, light, shade, physiological age of the leaf.
              The score I was able to achieve is 0.96927.
            </p>
            
            <span className={styles.tools}>python</span>
            <span className={styles.tools}>tensorflow/keras</span>
            <span className={styles.tools}>open-CV</span>

            <br></br>
            <br></br>
            <a className={styles.projectlink} href="https://www.kaggle.com/meemr5/plant-pathology-2020-eda-ia-ip-models">
              <b><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <GiWhiteBook/>
            </IconContext.Provider>Notebook</b></a>

          </div>
        </div>

        <div className={styles.projectcard}>
          <div className={styles.projectdescription}>
            <h2>Delhi Temperature Forecasting<span className={styles.projectyear}> - <em>2020</em></span></h2>
            <p>As a part of my work in Time-Series Analysis, I carried out this project to get
              the indepth insight of the Time-Series data. In this I explored the Delhi-Weather data
              and used different statistical-model for temperature forecasting.
            </p>
            
            <span className={styles.tools}>python</span>
            <span className={styles.tools}>sklearn</span>
            <span className={styles.tools}>statsmodels</span>

            <br></br>
            <br></br>
            <a className={styles.projectlink} href="https://www.kaggle.com/meemr5/delhi-temperature-forecasting-eda-sarimax/"><b><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <GiWhiteBook/>
            </IconContext.Provider>Notebook</b></a>

          </div>
          <img src={delhitemp} alt="Delhi-Temperature-Forecasting" className={styles.projectimage}></img>
        </div>

        <div className={styles.projectcard}>
          <img src={obgrobot} alt="Object-Following-Robot" className={styles.projectimage}></img>
          <div className={styles.projectdescription}>
            <h2>Object Following Robot<span className={styles.projectyear}> - <em>2019</em></span></h2>
            <p>It detects the object & according to the movements of the object, it follows the object.
              It uses Raspberry pi + Motor driver + Web Camera + OpenCV to follow an object
            </p>
            
            <span className={styles.tools}>python</span>
            <span className={styles.tools}>open-CV</span>
            <span className={styles.tools}>Raspberry-pi</span>

            <br></br>
            <br></br>
            <a className={styles.projectlink} href="https://github.com/memr5/Object-Following-Robot"><b><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <GiWhiteBook/>
            </IconContext.Provider>Notebook</b></a>

          </div>
        </div>

        <div className={styles.projectcard}>
          <div className={styles.projectdescription}>
            <h2>India Baby Names Generator<span className={styles.projectyear}> - <em>2020</em></span></h2>
            <p>I scraped the Indian-Baby-Names from a website and I used python for this purpose.
              To train a character-level text-generator I used tensorflow/keras in which I used Simple-RNNs layers.
              Some of the new names generated are in the image. 
            </p>
            
            <span className={styles.tools}>python</span>
            <span className={styles.tools}>tensorflow/keras</span>

            <br></br>
            <br></br>
            <a className={styles.projectlink} href="https://www.kaggle.com/meemr5/indian-baby-names-generator-text-processing-rnn"><b><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <GiWhiteBook/>
            </IconContext.Provider>Notebook</b></a>

          </div>
          <img src={babynames} alt="Indian-Baby-Names" className={styles.projectimage}></img>
        </div>

        <div className={styles.center}>
          <a className={styles.moreprojects} href="https://github.com/memr5/"><IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <FaGithub/>
            </IconContext.Provider>More Projects</a>
        </div>

      </div>

      <div className={styles.mystory} id="mystory">
        <div className={styles.center}>
          <span className={styles.divnumber}>4. </span><span className={styles.divname}>My Story!</span>
          <br></br>
          <br></br>
          <span>Here is something more about me.</span><br></br>
        </div>

        <div className={styles.mystoryrow}>
          <div className={styles.mystorycolumn}>
            <h2>
            <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <FaBlackTie/>
            </IconContext.Provider>My Professional Journey</h2>
            <p>
              Ever since I started this journey of my professional life,
              I have been obsessed of exploring and learning new things everyday. In the beginning, 
              I didn't know anything about programming and now <b>I love making Machines learn on 
              their own without being explictly programmed for it.</b>
              <br></br>
              <br></br>
              During this journey, I have explored and learned many things but I have developed deep
              interest in <b>Data-Science</b> field and I find it extremely satisfying.
              <br></br>
              <br></br>
              <b>Projects</b> have helped me gain <b>knowledge and experience</b>.
              The assistance of video tutorials, documentation & articles have helped me a lot.
              So far, It's been a very nice journey. 
            </p>
          </div>
          <div className={styles.mystorycolumn}>
            <h2>
            <IconContext.Provider value={{ size: '30px', style: { verticalAlign: 'middle', paddingRight:"10px"}}}>
              <FaAddressCard/>
            </IconContext.Provider>More About Me</h2>
            <ul>
              <li>I like to play video-games when I'm free.
                Some of my favourite games are <b>Fifa, Rainbow Six Siege, PUBG & COD.</b></li>
              <li>In my free time I like to watch movies, series & stand-up comedy.</li>
              <li>I love listening to music.</li>
              <li>I have interest in <em>Indian-Politics.</em></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className={styles.contactblock} id="contact">
        <h1>Want to contact me?</h1>
        <p>Here are my social media accounts or you can mail me.</p>
        <div className={styles.socialicon} >
          <a href="https://www.linkedin.com/in/mr5/">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaLinkedinIn/>
            </IconContext.Provider> 
          </a>

          <a href="https://github.com/memr5">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaGithub/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.kaggle.com/meemr5">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaKaggle/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.facebook.com/meet.ranoliya.9">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaFacebookF/>
            </IconContext.Provider> 
          </a>

          <a href="https://www.instagram.com/memr5__/">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaInstagram/>
            </IconContext.Provider> 
          </a>

          <a href="https://twitter.com/me_mr5_">
            <IconContext.Provider value={{ size: '25px' }}>
              <FaTwitter/>
            </IconContext.Provider> 
          </a>
        </div>
        
        <br></br>
        
        <div className={styles.emailbutton}>
          <a href="mailto:memr5.personal@protonmail.com">
            <IconContext.Provider value={{ size: '40px', style: { verticalAlign: 'text-bottom', paddingRight:"10px"}}}>
                <FaEnvelope/>
            </IconContext.Provider>
            Email
          </a>
        </div>

      </div>

      <div className={styles.footer} id="footer"><b>Meet Ranoliya 
      <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
        <FaRegCopyright/>
      </IconContext.Provider> 2020</b></div>

      <div className={styles.bottomnavbar}>
        <a href="#about">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <IoMdContact/>
          </IconContext.Provider>
        </a>

        <a href="#skillset">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <FaLaptopCode/>
          </IconContext.Provider>
        </a>

        <a href="#values">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <FaRegSmile/>
          </IconContext.Provider>
        </a>

        <a href="#projects">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <FaGitAlt/>
          </IconContext.Provider>
        </a>

        <a href="#mystory">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <FaBookOpen/>
          </IconContext.Provider>
        </a>

        <a href="#contact">
          <IconContext.Provider value={{ size: '50px', style: { verticalAlign: 'middle', padding:"10px"}}}>
            <MdEmail/>
          </IconContext.Provider>
        </a>
      </div>

    </body>
  )
}
